module.exports = __webpack_public_path__ + "static/media/panosta-svg-600x200.8c4a8fad.svg";